<template>
  <div v-if="embedded" class="col-12 refine-search-filter-embedded budget-filter-section--embedded">
    <div class="budget-filter-section__price">
      <RangeSelector
        :min="20000"
        :max="120000"
        :step="20000"
        v-model="localSelectedPrice"
        label="Price (RRP)"
        :markerLabel="priceOptions"
        :disabled="disabled || isFetchRatebookLoading"
      />
    </div>
    <RangeSelectorBudget
      v-model="localSelectedWeeklyBudget"
      :period.sync="localBudgetType"
      :markerLabel="weeklyOptions"
      label="Budget"
      pill-period-toggle
      :disabled="disabled || isFetchRatebookLoading"
    />
  </div>
  <CustomExpansionItem v-else class="col-12 q-mb-sm" label="Budget" v-model="isOpen">
    <div class="q-mb-sm">
      <RangeSelector
        :min="20000"
        :max="120000"
        :step="20000"
        v-model="localSelectedPrice"
        label="Price (RRP)"
        :markerLabel="priceOptions"
        :disabled="isPriceDisabled || disabled || isFetchRatebookLoading"
      />
    </div>
    <RangeSelectorBudget
      v-model="localSelectedWeeklyBudget"
      :period.sync="localBudgetType"
      :markerLabel="weeklyOptions"
      :disabled="isWeeklyBudgetDisabled || disabled || isFetchRatebookLoading"
    />
  </CustomExpansionItem>
</template>

<script>
import CustomExpansionItem from '../CustomExpansionItem';
import RangeSelector from '../Form/RangeSelector';
import RangeSelectorBudget from '../Form/RangeSelectorBudget.vue';

export default {
  name: 'BudgetFilterSection',
  props: {
    selectedPrice: {
      type: Object,
      default: () => ({
        min: null,
        max: 100000
      })
    },
    selectedWeeklyBudget: {
      type: Object,
      default: () => ({
        min: null,
        max: 200
      })
    },
    budgetType: {
      type: String,
      default: 'weekly'
    },
    priceOptions: {
      type: Array,
      default: () => []
    },
    weeklyOptions: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isFetchRatebookLoading: {
      type: Boolean,
      default: false
    },
    embedded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpen: false,
      localSelectedPrice: { ...this.selectedPrice },
      localSelectedWeeklyBudget: { ...this.selectedWeeklyBudget },
      localBudgetType: this.budgetType,
      // Separate flags for each watcher pair to prevent interference
      isSyncingPrice: false,
      isSyncingWeeklyBudget: false,
      isSyncingBudgetType: false
    };
  },
  computed: {
    isWeeklyBudgetDisabled() {
      return this.localSelectedPrice.min != null;
    },
    isPriceDisabled() {
      return this.localSelectedWeeklyBudget.min != null;
    }
  },
  watch: {
    selectedPrice(newValue) {
      if (!this.isSyncingPrice) {
        this.isSyncingPrice = true;
        this.localSelectedPrice = { ...newValue };
        this.$nextTick(() => {
          this.isSyncingPrice = false;
        });
      }
    },
    selectedWeeklyBudget(newValue) {
      if (!this.isSyncingWeeklyBudget) {
        this.isSyncingWeeklyBudget = true;
        this.localSelectedWeeklyBudget = { ...newValue };
        this.$nextTick(() => {
          this.isSyncingWeeklyBudget = false;
        });
      }
    },
    budgetType(newValue) {
      if (!this.isSyncingBudgetType) {
        this.isSyncingBudgetType = true;
        this.localBudgetType = newValue;
        this.$nextTick(() => {
          this.isSyncingBudgetType = false;
        });
      }
    },
    localSelectedPrice: {
      handler(newValue) {
        if (!this.isSyncingPrice) {
          this.$emit('update:selectedPrice', newValue);
          this.$emit('change');
        }
      },
      deep: true
    },
    localSelectedWeeklyBudget: {
      handler(newValue) {
        if (!this.isSyncingWeeklyBudget) {
          this.$emit('update:selectedWeeklyBudget', newValue);
          this.$emit('change');
        }
      },
      deep: true
    },
    localBudgetType(newValue) {
      if (!this.isSyncingBudgetType) {
        this.$emit('update:budgetType', newValue);
        this.$emit('change');
      }
    }
  },
  components: {
    CustomExpansionItem,
    RangeSelector,
    RangeSelectorBudget
  }
};
</script>

<style lang="sass" scoped>
@import '../../../styles/calculator/refine-embedded'

.budget-filter-section--embedded
  .budget-filter-section__price
    margin-bottom: 28px

  ::v-deep .primary-text
    +refine-embedded-heading
</style>
